import React from 'react';
import { Loader2 } from 'lucide-react';
interface LoadingScreenProps {
  message?: string;
}
export function LoadingScreen({
  message = 'Laden...'
}: LoadingScreenProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground space-y-4" data-id="element-3229" data-mp="2zn8lez5vgrym">
      <Loader2 className="w-8 h-8 text-primary animate-spin" data-id="element-3230" data-mp="2vmeury11oz21" />
      <p className="text-muted-foreground font-medium animate-pulse" data-id="element-3231" data-mp="2vk2h3x2blaus">
        {message}
      </p>
    </div>;
}